import styled from "styled-components";

export const ProjectsSectionWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const ProjectList = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
  grid-auto-flow: dense;
  grid-auto-rows: auto;
  grid-gap: 1rem;
  padding: 1rem;
`;

export const ProjectCard = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;

  & > img {
    width: 100%;
    height: 100%;
    opacity: 0.5;
  }

  & > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid rgba(128, 128, 128, 0.5);
    transition: all 0.2s ease;
    border-radius: 2px;
    opacity: 0;
    visibility: hidden;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;

    & > svg {
      color: rgba(128, 128, 128, 0.5);
      font-size: 3rem;
    }
  }

  &:hover > div {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid rgba(128, 128, 128, 0.5);
    width: 80%;
    height: 80%;
    opacity: 1;
    visibility: visible;
  }

  &:hover > img {
    opacity: 0.1;
  }
`;
